import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiOffers = () => {
 const { auth } = contextApp();

 const OfferApi = axios.create({
  baseURL: urls.offer(),
  headers: { 'x-access-token': auth?.token }
 });

 const getOffer = async offer => (await OfferApi.get('/' + offer)).data;

 const getOffers = async (params = {}) => (await OfferApi.get('/', { params })).data;

 const createOffer = async offer => (await OfferApi.post('/', offer)).data;

 const updateOffer = async offer => (await OfferApi.post('/', offer)).data;

 const removeOffer = async offer => (await OfferApi.post('/', offer)).data;

 return { getOffer, getOffers, createOffer, updateOffer, removeOffer };
};
